import LiveEvent from '../../components/live/live';

/**
 * Отзывы на странице товара (_parts/product-base/_product-base-reviews.html.twig).
 *
 * [data-reviews] - блок отзывов, [data-reviews-per-page] - сколько отзывов открывать за раз
 * [data-reviews-item] - отзыв (скрытые - с атрибутом hidden)
 * [data-reviews-more] - кнопка «Показать еще»
 * [data-reviews-link] - ссылка на отзывы в шапке товара: открывает вкладку (аккордеон на мобильных) и прокручивает к ней
 */

/** Запас сверху при прокрутке к отзывам - чтобы их не закрыла липкая шапка */
const SCROLL_OFFSET = 150;

function scrollToElement(element) {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET,
    behavior: 'smooth',
  });
}

/** Если блок внутри раскрытого аккордеона - подогнать высоту аккордеона под новое содержимое */
function updateAccordionHeight(reviews) {
  const block = reviews.closest('[data-accordion-block]');
  if (block && block.closest('[data-accordion-element]').classList.contains('_opened')) {
    block.style.height = `${block.children[0].clientHeight}px`;
  }
}

new LiveEvent('click', '[data-reviews-more]', function showMore(e) {
  e.preventDefault();
  const reviews = this.closest('[data-reviews]');
  const perPage = parseInt(reviews.dataset.reviewsPerPage, 10) || 5;
  const hidden = reviews.querySelectorAll('[data-reviews-item][hidden]');

  Array.from(hidden).slice(0, perPage).forEach((item) => {
    item.hidden = false;
  });

  if (hidden.length <= perPage) {
    this.remove();
  }

  updateAccordionHeight(reviews);
});

new LiveEvent('click', '[data-reviews-link]', (e) => {
  e.preventDefault();

  // Вкладки на десктопе и аккордеон на мобильных есть в разметке одновременно, видно что-то одно
  const tabLink = document.querySelector('.smart-tabs a[href="#tab-reviews"]');
  if (tabLink && tabLink.offsetParent !== null) {
    tabLink.click();
    scrollToElement(tabLink);
    return;
  }

  const accordion = document.querySelector('[data-reviews-accordion]');
  if (accordion) {
    if (!accordion.classList.contains('_opened')) {
      accordion.querySelector('[data-accordion-link]').click();
    }
    scrollToElement(accordion);
  }
});
